import {DProject} from "../../joiner";
import {UpdateProjectRequest} from "./UpdateProjectRequest";

export class UpdateUserRequest {

    id?: string;
    _Id?: string;
    name?: string;
    surname?: string;
    nickname?: string;
    country?: string;
    email?: string
    affiliation?: string;
    newsletter?: boolean;


}

